module.exports = __webpack_public_path__ + "img/img-ygr-d.4d43580c.png";